import {ChangeDetectionStrategy, Component, inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AppService} from '@app/app.service';
import {TokenStorage} from '@app/core/token.storage';
import {IAppServiceLanguages} from '@app/app.interface';
import {AppHelper} from '@app/core/app.helper';
import {DesignerFilterService} from '@app/modules/designer-filter/designer-filter.service';
import {NotificationsService} from '@app/modules/notifications/notifications.service';
import {BehaviorSubject} from 'rxjs';
import {TuiDestroyService} from '@taiga-ui/cdk';
import {takeUntil} from 'rxjs/operators';

/**
 * Класс шапки страницы
 */
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [TuiDestroyService],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnChanges {
    readonly #destroy$: TuiDestroyService = inject(TuiDestroyService);
    readonly #showProfilerButton$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    /** Количество записей профайлера */
    profilerCount: string = '';
    /** Флаг состояние системы (внешняя / внутренняя) */
    @Input() public isPublic: boolean = true;
    /** Данные роута */
    @Input() public routeData: any;
    /** Элемент контейнера страницы */
    private _layoutWrapperContainer: HTMLDivElement;

    /**
     * Установка элемента контейнера страницы
     * @param {HTMLDivElement} value элемент контейнера страницы
     */
    @Input()
    set layoutWrapperContainer(value: HTMLDivElement) {
        this._layoutWrapperContainer = value;
    }

    /**
     * Получение элемента контейнера страницы
     */
    get layoutWrapperContainer(): HTMLDivElement {
        return this._layoutWrapperContainer;
    }

    /** Поток для получения значения - отображать ли кнопку профайлер */
    public get showProfilerButton$() {
        return this.#showProfilerButton$.asObservable();
    }

    /** Флаг открытого меню */
    public openMenu = false;

    public currentLang: IAppServiceLanguages = null;

    /**
     * Конструктор
     * @param router роутинг
     * @param appService сервис ко внешним ресурсам
     * @param token класс работы с токеном
     * @param dialog диалог
     * @param spinner прелоадер
     * @param notifier сервис всплывающих сообщений
     * @param filterService сервис фильтров
     * @param dialogConfirm диалог подтверждения действия
     * @param service сервис уведомлений
     */
    constructor(
        public appService: AppService,
        public service: NotificationsService,
        public token: TokenStorage,
        public filterService: DesignerFilterService,
    ) {
        this.currentLang = AppHelper.getCurrentLanguage(this.appService);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (this.appService.isAuth) {
            this.#showProfilerButton$.next(this.appService.accessMatrix?.profiler?.show === 1);
        } else {
            this.#showProfilerButton$.next(false);
        }
    }

    ngOnInit() {
        if (this.appService.isAuth) {
            if (this.appService.accessMatrix
                && Object.keys(this.appService.accessMatrix).includes('notification_all')
                && Object.keys(this.appService.accessMatrix.notification_all).includes('show')
                && this.appService.accessMatrix.notification_all.show === 1
                && this.service.notificationFlag === false) {
                this.service.notificationFlag = true;
            }
        }

        this.showProfilerButton$.pipe(takeUntil(this.#destroy$)).subscribe((val) => {
            let count: number | string = '';
            if (val) {
                count = this.appService.getSettingsByKey('profilerCount');
                if (count && count > 99) {
                    count = '99+';
                } else if (count && count < 99) {
                    count = String(count);
                } else {
                    count = '';
                }
            }

            this.profilerCount = count;
        });

    }

    /**
     * Переключение языка
     * @param {string} lang язык
     */
    setCurrentLang(lang: any) {
        this.currentLang = lang;
        this.token.saveCurrentLang(lang.lang);
        window.location.reload();
    }

    /**
     * Сворачивание/разворачивание левого меню
     * @param isPublic флаг публичной страницы
     */
    public onToggleSidenav = (isPublic: boolean) => {
        if (!isPublic) {
            this.layoutWrapperContainer.classList.toggle('layout-wrapper-menu-open');
        }
        this.openMenu = !this.openMenu;
    };
}
